var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-1"},[(_vm.fileImage)?_c('b-img',{attrs:{"thumbnail":"","fluid":"","src":_vm.fileImage,"alt":"Pasfoto"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }